import CONFIG from '../../config';

const actions = {
  creditloanLoanDocument(context, params) {
    context.commit('ADD_LOG', { request: 'creditloanLoanDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('creditloanLoanDocument', params.loanId)}`, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          responseType: 'blob'
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditloanLoanDocument' });
          resolve(response.data);
        })
        .catch(async (err) => {
          const errBlob = JSON.parse(await err.response.data.text());
          context.commit('REMOVE_LOG', { request: 'creditloanLoanDocument' });
          context.dispatch('resolveError', { errBlob })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditloanAmountChange(context, params) {
    context.commit('ADD_LOG', { request: 'creditloanAmountChange' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('creditloanAmountChange', params.loanId)}`, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditloanAmountChange' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditloanAmountChange' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  submitCreditloanLoanDocument(context, params) {
    context.commit('ADD_LOG', { request: 'submitCreditloanLoanDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('v2CreditloanLoanDocument', params.loanId)}`, {}, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'submitCreditloanLoanDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'submitCreditloanLoanDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanSignMethod(context, params) {
    context.commit('ADD_LOG', { request: 'creditLoanSignMethod' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('creditLoanSignMethod', params.loanId)}`, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanSignMethod' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanSignMethod' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanSanctionDocument(context, params) {
    context.commit('ADD_LOG', { request: 'creditLoanSanctionDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('creditLoanSanctionDocument', params.loanId)}`, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          responseType: 'blob'
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanSanctionDocument' });
          resolve(response.data);
        })
        .catch(async (err) => {
          const errBlob = JSON.parse(await err.response.data.text());
          context.commit('REMOVE_LOG', { request: 'creditLoanSanctionDocument' });
          context.dispatch('resolveErrorCodeForEmanDateKyc', { errBlob })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  aadharEsign(context, params) {
      context.commit('ADD_LOG', { request: 'aadharEsign' });
      return new Promise((resolve, reject) => {
        this.axios
          .post(`${CONFIG.getEndpoint('aadharEsign', params.loanId)}`, {}, {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            params: params.urlParams
          })
          .then((response) => {
            context.commit('REMOVE_LOG', { request: 'aadharEsign' });
            resolve(response.data);
          })
          .catch((err) => {
            context.commit('REMOVE_LOG', { request: 'aadharEsign' });
            context.dispatch('resolveError', { err })
              .catch((resolvedError) => {
                reject(resolvedError);
              });
          });
      });
    },
    aadharEsignSanction(context, params) {
      context.commit('ADD_LOG', { request: 'aadharEsignSanction' });
      return new Promise((resolve, reject) => {
        this.axios
          .get(`${CONFIG.getEndpoint('aadharEsignSanction', params.loanId)}`, {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            params: params.urlParams
          })
          .then((response) => {
            context.commit('REMOVE_LOG', { request: 'aadharEsignSanction' });
            resolve(response.data);
          })
          .catch((err) => {
            context.commit('REMOVE_LOG', { request: 'aadharEsignSanction' });
            context.dispatch('resolveError', { err })
              .catch((resolvedError) => {
                reject(resolvedError);
              });
          });
      });
    },
  v6EmandateBanks(context, params) {
    context.commit('ADD_LOG', { request: 'v6EmandateBanks' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('v6EmandateBanks', params.bankName)}`, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v6EmandateBanks' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v6EmandateBanks' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  panToGst(context, params) {
    context.commit('ADD_LOG', { request: 'panToGst' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('panToGst', params)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'panToGst' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'panToGst' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  availableSlots(context) {
    context.commit('ADD_LOG', { request: 'availableSlots' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('availableSlots')}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'availableSlots' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'availableSlots' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  bookSlots(context, params) {
    context.commit('ADD_LOG', { request: 'bookSlots' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(`${CONFIG.getEndpoint('bookSlots', params.applicationId)}`, params.rowData, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'bookSlots' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'bookSlots' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  glibUploadBankStatement(context, params) {
    context.commit('ADD_LOG', { request: 'glibUploadBankStatement' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(`${CONFIG.getEndpoint('glibUploadBankStatement', params.applicationId)}`, params.rowData, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'glibUploadBankStatement' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'glibUploadBankStatement' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationDiscardDocument(context, params) {
    context.commit('ADD_LOG', { request: 'applicationDiscardDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationDiscardDocument', params.docId)}`, {}, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationDiscardDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationDiscardDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  digiTapMobileUdyamDetails(context, params) {
    context.commit('ADD_LOG', { request: 'digiTapMobileUdyamDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('digiTapMobileUdyamDetails', params.applicationId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'digiTapMobileUdyamDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'digiTapMobileUdyamDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  digiTapUdyamToBusiness(context, params) {
    context.commit('ADD_LOG', { request: 'digiTapUdyamToBusiness' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(`${CONFIG.getEndpoint('digiTapUdyamToBusiness', params.applicationId)}`, params.rowData, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'digiTapUdyamToBusiness' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'digiTapUdyamToBusiness' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  bankStatementStatus(context, params) {
    context.commit('ADD_LOG', { request: 'bankStatementStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('bankStatementStatus', params.applicationId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'bankStatementStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'bankStatementStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMandateStatus(context, params) {
    context.commit('ADD_LOG', { request: 'applicationMandateStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationMandateStatus', params.loanId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams,
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMandateStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMandateStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  loanSignStatus(context, params) {
    context.commit('ADD_LOG', { request: 'loanSignStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('loanSignStatus', params.loanId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams,
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'loanSignStatus' });
          context.commit('SAVE_NBFC_NAME', response?.data?.nbfcName || '');
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'loanSignStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  signLoanDocument(context, params) {
    context.commit('ADD_LOG', { request: 'signLoanDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('signLoanDocument'), { ...params }, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'signLoanDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'signLoanDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  kfsAadharEsign(context, params) {
    context.commit('ADD_LOG', { request: 'kfsAadharEsign' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('kfsAadharEsign', params.loanId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'kfsAadharEsign' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'kfsAadharEsign' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanKfsDocument(context, params) {
    context.commit('ADD_LOG', { request: 'creditLoanKfsDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('creditLoanKfsDocument', params.loanId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          },
          responseType: 'blob',
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanKfsDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanKfsDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationAddress(context, params) {
    context.commit('ADD_LOG', { request: 'applicationAddress' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationAddress', params.applicationId)}`, {
          headers: {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddress' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddress' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
